import { useEffect, useRef, useState } from "react";

interface UseLoadingStateProps {
  loading: boolean;
  minDisplayTime?: number;
}

export const useDotLoadingState = ({
  loading,
  minDisplayTime = 1000
}: UseLoadingStateProps) => {
  const [showLoading, setShowLoading] = useState(false);
  const loadingStartTimeRef = useRef<number | null>(null);

  useEffect(() => {
    if (loading) {
      loadingStartTimeRef.current = Date.now();
      setShowLoading(true);
    } else if (loadingStartTimeRef.current) {
      const elapsedTime = Date.now() - loadingStartTimeRef.current;
      if (elapsedTime < minDisplayTime) {
        const remainingTime = minDisplayTime - elapsedTime;
        setTimeout(() => {
          setShowLoading(false);
          loadingStartTimeRef.current = null;
        }, remainingTime);
      } else {
        setShowLoading(false);
        loadingStartTimeRef.current = null;
      }
    }
  }, [loading, minDisplayTime]);

  return showLoading;
};
